import React from "react";
import styles from "./admin.module.scss";

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width = "100%",
  height = 16,
  radius,
}) => (
  <span
    className={styles.skel}
    style={{ display: "block", width, height, borderRadius: radius }}
    aria-hidden="true"
  />
);

export default Skeleton;
